export const navTabs = [
  {
    title: "Moon",
  },
  {
    title: "Mars",
  },
  {
    title: "Europa",
  },
  {
    title: "Titan",
  },
];
